import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import * as locationReq from '../../../redux/dashboard/requests/appointment-locations-req';
import * as createAppointmentReq from '../../../redux/dashboard/requests/create-appointment-req';
import {
  selectAppointmentsRecordLocations,
  selectLoadingAppointmentsLocations,
  selectSendingCreateAppointmentReq,
  selectRejectedCreateAppointmentReq,
  selectCreateAppointmentReqError,
} from '../../../redux/dashboard/selectors';
import { actions as reqAllUsers } from '../../../redux/board/reqAllUsers';
import {
  usersSelector,
  sendingSelector,
} from '../../../redux/board/selectors/AllUsers';
import styles from '../../DependentForm/styles.styl';

const mapStateToProps = state => ({
  locationsList: selectAppointmentsRecordLocations(state),
  loadingLocations: selectLoadingAppointmentsLocations(state),
  providersList: usersSelector(state),
  isLoadingProviders: sendingSelector(state),
  pending: selectSendingCreateAppointmentReq(state),
  rejected: selectRejectedCreateAppointmentReq(state),
  errors: selectCreateAppointmentReqError(state),
});

const mapDispatchToProps = {
  locationsReq: locationReq.actions.send,
  createAppointment: createAppointmentReq.actions.send,
  clearAppointmentReq: createAppointmentReq.actions.clear,
  getProviders: reqAllUsers.send,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/DashboardVisitInfo/enhance.js